/**
 * GA4 event helper.
 *
 * GTM is loaded globally in the root layout, so everything goes through the
 * dataLayer rather than a gtag call of our own. Safe to call during render or
 * on the server — it no-ops when the dataLayer is not there.
 */

export type GAEventName =
  | "registration_qr_view"
  | "registration_qr_click"
  | "pickcelgpt_section_view"
  | "event_details_view"
  | "infocomm_sticky_header_click"
  | "generate_lead"
  | "sign_up";

type GAEventParams = Record<string, string | number | boolean | undefined>;

interface DataLayerWindow extends Window {
  dataLayer?: Array<Record<string, unknown>>;
}

export function trackGAEvent(event: GAEventName, params: GAEventParams = {}): void {
  if (typeof window === "undefined") return;

  const target = window as DataLayerWindow;
  if (!Array.isArray(target.dataLayer)) return;

  const payload: Record<string, unknown> = { event };
  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined) payload[key] = value;
  }

  target.dataLayer.push(payload);
}

/** GA4 key event: a demo lead was saved by the server. Call once per successful submit. */
export function trackDemoLead(): void {
  trackGAEvent("generate_lead", {
    form_type: "demo",
    form_location: typeof window === "undefined" ? undefined : window.location.pathname,
  });
}

/** GA4 key event: a gated guide download request was saved by the server. Call once per successful submit. */
export function trackLeadMagnetLead(): void {
  trackGAEvent("generate_lead", {
    form_type: "lead_magnet",
    form_location: typeof window === "undefined" ? undefined : window.location.pathname,
  });
}
